import { executeRequest, JFSRequest } from '@jfs/network'
import { dateFormatter, DateFormatTypes, encryptAccNumber, isSuccessResponse } from '../utils'
import { accountTypeArr } from '../utils/constants'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const getModes = (modes: any) => {
  const retStr = []
  modes?.map((item) => {
    if (item.isChecked) {
      retStr.push(item.id)
    }
  })
  return retStr?.join('|')
}
const addSourceAccountConfig = (tokens: any, data: any, isAdd: boolean) => {
  const { REACT_APP_CHANNEL_ID = '' } = window?._env_
  const request: JFSRequest<{}> = {
    apiPath: getUrl(isAdd ? APIEndPoints.addSourceAccount : APIEndPoints.updateSourceAccount),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      entity: {
        initiatingEntityId: REACT_APP_CHANNEL_ID,
        groupId: data?.groupId,
        subGroupId: data?.subGroupId,
      },
      payoutSourceAccount: {
        id: data?.id,
        methodType: getModes(data?.methodTypes),
        transactionMode: getModes(data?.transactionModes),
        methodSubType: getModes(data?.methodSubTypes),
        entityType: getModes(data?.entityType),
        accountNumber: encryptAccNumber(data?.accNumber),
        bankIfsc: data?.ifscCode,
        bankId: 1000,
        bankName: 'ICICI',
        accountType: accountTypeArr?.find((item) => item.value === data?.accType)?.id,
        processingEntity: data?.processingEntity,
        startDate: dateFormatter(new Date(data?.startDate), DateFormatTypes.YYYY_MM_dd_HHMM),
        endDate: dateFormatter(new Date(data?.endDate), DateFormatTypes.YYYY_MM_dd_HHMM),
        remarks: data?.remarks,
        metadata: {
          accountName: data?.accountName,
          clientCode: data?.clientCode,
        },
      },
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { addSourceAccountConfig }
